import { assert, release } from './Debug';
/**
 * An extremely naive cache with a maximum size.
 * TODO: LRU
 */
var Cache = /** @class */ (function () {
    function Cache(maxSize) {
        this._data = Object.create(null);
        this._size = 0;
        this._maxSize = maxSize;
    }
    Cache.prototype.get = function (key) {
        return this._data[key];
    };
    Cache.prototype.set = function (key, value) {
        release || assert(!(key in this._data)); // Cannot mutate cache entries.
        if (this._size >= this._maxSize) {
            return false;
        }
        this._data[key] = value;
        this._size++;
        return true;
    };
    return Cache;
}());
export { Cache };
